// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"a1d76067","227":"567bc3e6","279":"deb52caa","288":"d91b3664","692":"e55cbd3f","720":"7a54e061","903":"137a9b13","965":"eba44af0","998":"a54d7f4e"}[chunkId] + ".chunk.js";
};